import { odmien } from "../../lib/polski.js";
import type { MowcaRaportu } from "../../lib/raportOceny.js";
import { Card } from "../ui/Card.js";
import { RadioGroup } from "../ui/Choice.js";

/**
 * "Który mówca to Ty?": karta na ekranie wyniku, gdy w rozmowie mowilo kilka osob, a uzytkownik nie wskazal siebie
 * (nagranie i tekst bez podpisow: mowcow znamy dopiero po przetworzeniu). Wybor zapada od razu po kliknieciu i jest
 * zapisywany na serwerze; do tego czasu nie pokazujemy wyniku, bo nie wiadomo, o kim ma byc.
 *
 * Lista wyboru (radio), a nie przelacznik segmentowy: przelacznik zawsze ma zaznaczona jedna opcje, a tu na poczatku
 * nie jest wybrane nic.
 */
export function KartaWyboruMowcy({
  kandydaci,
  zapisuje,
  onWybierz,
}: {
  kandydaci: readonly MowcaRaportu[];
  /** Trwa zapis wyboru: opcje sa wygaszone, zeby drugie klikniecie nie wyprzedzilo pierwszego. */
  zapisuje: boolean;
  onWybierz: (klucz: string) => void;
}): React.JSX.Element {
  return (
    <Card tytul="Który mówca to Ty?">
      <p className="wynik-uwaga">
        Wybierz siebie, a pokażemy wynik dla Ciebie: mocne strony, rzeczy do poprawy i ćwiczenie. Wybór możesz później zmienić.
      </p>
      <RadioGroup
        etykieta="Mówca"
        nazwa="mowca-uzytkownika"
        wartosc=""
        opcje={kandydaci.map((m) => ({
          wartosc: m.klucz,
          etykieta: m.nazwa,
          opis: `${m.liczbaWypowiedzi} ${odmien(m.liczbaWypowiedzi, "wypowiedź", "wypowiedzi", "wypowiedzi")}`,
          wylaczona: zapisuje,
        }))}
        onZmiana={onWybierz}
      />
      {zapisuje && (
        <p className="wynik-uwaga" role="status">
          Zapisuję wybór...
        </p>
      )}
    </Card>
  );
}
